import React from "react";
import { Link } from "react-router-dom";
import "./style.css";
import AlertBanner from "../../components/AlertBanner";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { dataportfolio, meta } from "../../content_option";

export const Portfolio = () => {
  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title> Portfolio | {meta.title} </title>{" "}
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3">
          <Col lg="8">
            <h1 className="display-4 mb-4"> Portfolio </h1>{" "}
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
          <div>
            <AlertBanner />
          </div>
        </Row>
    <div className="po_items_ho">
  {dataportfolio.map((item, index) => (
    <div className="po_item" key={index}>
      <img src={item.img} alt={`Project ${index + 1}`} />

      <div className="content">
        <p className="description">{item.desctiption}</p>

        <div className="buttons">
          {item.link && (
            <a className="btn" href={item.link} target="_blank" rel="noopener noreferrer">
              Live
            </a>
          )}

          {item.slug && (
            <Link className="btn" to={`/case-study-${item.slug}`}>
              Case Study
            </Link>
          )}
        </div>
      </div>
    </div>
  ))}
</div>

      </Container>
    </HelmetProvider>
  );
};
